export const GETINFOSGITHUB = "getInfosAuthGitHub";
export const GETINFOSGITHUBERROR = "getInfosAuthGitHubError";

export const ISLOGGED = "userIsLogged";
export const LOADING = "loading";
export const ISLOADED = "loaded";

export const GETDASHBOARD = "getDataDashboard";
export const VISIBILITY = "changeVisibility";

export const EDITDATA = "editDatainEditor";
export const NEWENTRY = "newEntry";

export const SENDNEWENTRY = "sendNewEntry";
export const UPDATEENTRY = "updateEntry";
export const DELETEENTRY = "deleteEntry";

export const NEWGROUP = "newGroup";
export const GETGROUPS = "getGroup";
export const DELETEGROUP = "deleteGroup";



// WEBPACK FOOTER //
// ./src/store/types.js